import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M13.4009 12.0001L21.6119 3.78905C21.9989 3.40205 21.9989 2.77505 21.6119 2.38805C21.2249 2.00105 20.5979 2.00105 20.2109 2.38805L11.9999 10.5991L3.78793 2.38705C3.40093 2.00005 2.77393 2.00005 2.38693 2.38705C1.99993 2.77405 1.99993 3.40105 2.38693 3.78805L10.5989 12.0001L2.38693 20.2111C1.99993 20.5981 1.99993 21.2251 2.38693 21.6121C2.57993 21.8051 2.83393 21.9021 3.08793 21.9021C3.34193 21.9021 3.59493 21.8051 3.78893 21.6121L12.0009 13.4011L20.2119 21.6121C20.4049 21.8051 20.6589 21.9021 20.9129 21.9021C21.1669 21.9021 21.4199 21.8051 21.6139 21.6121C22.0009 21.2251 22.0009 20.5981 21.6139 20.2111L13.4029 12.0001H13.4009Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Cross');

export default Icon;
